import React from 'react'
import classNames from 'classnames'
import {useInjection} from 'dna-react-ioc'
import {IDigitalReceiptsButtonsStore} from '~/code/pages/DigitalReceipts/components/DigitalReceiptsButtons'
import {StartYourFreeTrialButton, GoToDigitalReceiptsButton} from '..'

import {DigitalReceiptsButtonsProps} from './props'
import styles from './styles.scss'

export const DigitalReceiptsButtonsSymbol = Symbol('DigitalReceiptsButtonsStore')

export const DigitalReceiptsButtons = ({className}: DigitalReceiptsButtonsProps) => {
    const store = useInjection<IDigitalReceiptsButtonsStore>(DigitalReceiptsButtonsSymbol)

    return (
        <>
            <div className={classNames(styles.root, className)}>
                <StartYourFreeTrialButton store={store} />
                <GoToDigitalReceiptsButton store={store} />
            </div>
        </>
    )
}
